import { TRACK_EVENTS } from "core/consts";
import { FileHISStateful, Filev2, FileState } from "core/types";
import { useEffect } from "react";
import { useTracking } from "react-tracking";

export function useTrackFilesCount({
  receivedFiles,
  unavailableFiles,
  uploadedFilesV2,
}: {
  receivedFiles: Filev2[] | null;
  unavailableFiles: FileHISStateful[] | null;
  uploadedFilesV2: FileState[] | null;
}) {
  const { trackEvent } = useTracking();

  useEffect(() => {
    const latestUploadedFiles = uploadedFilesV2?.length;
    const latestReceivedFiles = receivedFiles?.length;
    const latestUnavailableFiles = unavailableFiles?.length;

    const timer = setTimeout(() => {
      if (
        typeof receivedFiles?.length === "number" &&
        receivedFiles.length === latestReceivedFiles &&
        typeof unavailableFiles?.length === "number" &&
        unavailableFiles.length === latestUnavailableFiles &&
        typeof uploadedFilesV2?.length === "number" &&
        uploadedFilesV2.length === latestUploadedFiles
      ) {
        trackEvent({
          available_files: uploadedFilesV2?.length,
          name: TRACK_EVENTS.FILES_COUNT,
          received_files: receivedFiles?.length,
          unavailable_files: unavailableFiles?.length,
        });
      }
    }, 2000);

    return () => {
      clearTimeout(timer);
    };
  }, [uploadedFilesV2, receivedFiles, unavailableFiles]);
}
